export type RevShareStatus = 'activo' | 'finalizado' | 'pendiente';

export interface RevShareCampaign {
  id: number;
  campaignName: string;
  radioName: string;
  radioFrequency: string;
  radioCity: string;
  totalAmount: number;
  radioPercent: number;
  rfwPercent: number;
  radioEarnings: number;
  rfwEarnings: number;
  impressions: number;
  clicks: number;
  listeners: number;
  engagement: number;
  followers: number;
  startDate: string;
  endDate: string;
  status: RevShareStatus;
  category: string;
  advertiserName: string;
  advertiserLogo?: string;
}

export const revShareCampaigns: RevShareCampaign[] = [
  {
    id: 1,
    campaignName: 'Lanzamiento App Móvil RFW',
    radioName: 'Radio Éxito FM',
    radioFrequency: '98.5 FM',
    radioCity: 'Ciudad de México',
    totalAmount: 45000,
    radioPercent: 70,
    rfwPercent: 30,
    radioEarnings: 31500,
    rfwEarnings: 13500,
    impressions: 245000,
    clicks: 18200,
    listeners: 34000,
    engagement: 7.4,
    followers: 8200,
    startDate: '2026-04-01',
    endDate: '2026-07-01',
    status: 'activo',
    category: 'tecnologia',
    advertiserName: 'RadioFrecuenciaWeb',
  },
  {
    id: 2,
    campaignName: 'Festival Cumbia 2026',
    radioName: 'Radio Estéreo Capital',
    radioFrequency: '102.1 FM',
    radioCity: 'Medellín',
    totalAmount: 32000,
    radioPercent: 70,
    rfwPercent: 30,
    radioEarnings: 22400,
    rfwEarnings: 9600,
    impressions: 178000,
    clicks: 12300,
    listeners: 28000,
    engagement: 6.9,
    followers: 5400,
    startDate: '2026-05-15',
    endDate: '2026-08-15',
    status: 'activo',
    category: 'entretenimiento',
    advertiserName: 'Festival de la Cumbia',
  },
  {
    id: 3,
    campaignName: 'Patrocinio Educativo Universitario',
    radioName: 'Radio Cultura Digital',
    radioFrequency: '91.3 FM',
    radioCity: 'Buenos Aires',
    totalAmount: 28000,
    radioPercent: 65,
    rfwPercent: 35,
    radioEarnings: 18200,
    rfwEarnings: 9800,
    impressions: 132000,
    clicks: 8900,
    listeners: 21000,
    engagement: 6.7,
    followers: 3600,
    startDate: '2026-03-01',
    endDate: '2026-09-01',
    status: 'activo',
    category: 'educacion',
    advertiserName: 'Universidad Virtual',
  },
  {
    id: 4,
    campaignName: 'Copa América Especial',
    radioName: 'Radio Deportiva Total',
    radioFrequency: '95.7 FM',
    radioCity: 'Guadalajara',
    totalAmount: 52000,
    radioPercent: 75,
    rfwPercent: 25,
    radioEarnings: 39000,
    rfwEarnings: 13000,
    impressions: 310000,
    clicks: 24500,
    listeners: 48000,
    engagement: 7.9,
    followers: 11200,
    startDate: '2026-06-01',
    endDate: '2026-07-31',
    status: 'activo',
    category: 'deportes',
    advertiserName: 'AutoRepuestos Mendoza',
  },
  {
    id: 5,
    campaignName: 'Gastronomía Regional Tour',
    radioName: 'Radio Peninsular',
    radioFrequency: '101.9 FM',
    radioCity: 'Mérida',
    totalAmount: 18500,
    radioPercent: 70,
    rfwPercent: 30,
    radioEarnings: 12950,
    rfwEarnings: 5550,
    impressions: 87000,
    clicks: 5400,
    listeners: 15000,
    engagement: 6.2,
    followers: 2800,
    startDate: '2026-04-15',
    endDate: '2026-07-15',
    status: 'activo',
    category: 'gastronomia',
    advertiserName: 'Restaurante La Parrilla',
  },
  {
    id: 6,
    campaignName: 'Fitness Total Promo',
    radioName: 'Radio Éxito FM',
    radioFrequency: '98.5 FM',
    radioCity: 'Ciudad de México',
    totalAmount: 22000,
    radioPercent: 70,
    rfwPercent: 30,
    radioEarnings: 15400,
    rfwEarnings: 6600,
    impressions: 115000,
    clicks: 7800,
    listeners: 19500,
    engagement: 6.8,
    followers: 4100,
    startDate: '2026-05-01',
    endDate: '2026-08-01',
    status: 'activo',
    category: 'salud',
    advertiserName: 'Gimnasio PowerFit',
  },
  {
    id: 7,
    campaignName: 'Hotel Brisas Turismo Premium',
    radioName: 'Radio Costa Azul',
    radioFrequency: '88.7 FM',
    radioCity: 'San José',
    totalAmount: 25000,
    radioPercent: 70,
    rfwPercent: 30,
    radioEarnings: 17500,
    rfwEarnings: 7500,
    impressions: 142000,
    clicks: 9600,
    listeners: 22000,
    engagement: 6.8,
    followers: 4900,
    startDate: '2026-03-15',
    endDate: '2026-06-15',
    status: 'finalizado',
    category: 'turismo',
    advertiserName: 'Hotel Brisas del Pacífico',
  },
  {
    id: 8,
    campaignName: 'Tecnología Verde Promo',
    radioName: 'Radio Industria',
    radioFrequency: '93.5 FM',
    radioCity: 'Monterrey',
    totalAmount: 38000,
    radioPercent: 70,
    rfwPercent: 30,
    radioEarnings: 26600,
    rfwEarnings: 11400,
    impressions: 198000,
    clicks: 14100,
    listeners: 31000,
    engagement: 7.1,
    followers: 6700,
    startDate: '2026-05-15',
    endDate: '2026-08-15',
    status: 'activo',
    category: 'tecnologia',
    advertiserName: 'TechNova',
  },
  {
    id: 9,
    campaignName: 'Feria del Libro Cultural',
    radioName: 'Radio Cultura Digital',
    radioFrequency: '91.3 FM',
    radioCity: 'Buenos Aires',
    totalAmount: 15000,
    radioPercent: 70,
    rfwPercent: 30,
    radioEarnings: 10500,
    rfwEarnings: 4500,
    impressions: 68000,
    clicks: 4200,
    listeners: 12000,
    engagement: 6.2,
    followers: 2200,
    startDate: '2026-06-01',
    endDate: '2026-07-15',
    status: 'pendiente',
    category: 'cultura',
    advertiserName: 'Librería El Ateneo',
  },
  {
    id: 10,
    campaignName: 'AutoShow 2026 Monterrey',
    radioName: 'Radio Industria',
    radioFrequency: '93.5 FM',
    radioCity: 'Monterrey',
    totalAmount: 41000,
    radioPercent: 75,
    rfwPercent: 25,
    radioEarnings: 30750,
    rfwEarnings: 10250,
    impressions: 220000,
    clicks: 16200,
    listeners: 36000,
    engagement: 7.4,
    followers: 8100,
    startDate: '2026-06-15',
    endDate: '2026-09-15',
    status: 'pendiente',
    category: 'automotriz',
    advertiserName: 'AutoLux Premium',
  },
  {
    id: 11,
    campaignName: 'Festival Nocturno Electrónica',
    radioName: 'Radio TechBeats',
    radioFrequency: '97.3 FM',
    radioCity: 'San Salvador',
    totalAmount: 29000,
    radioPercent: 70,
    rfwPercent: 30,
    radioEarnings: 20300,
    rfwEarnings: 8700,
    impressions: 156000,
    clicks: 11200,
    listeners: 26000,
    engagement: 7.2,
    followers: 5800,
    startDate: '2026-05-01',
    endDate: '2026-06-30',
    status: 'finalizado',
    category: 'musica',
    advertiserName: 'Festival Electrónica SV',
  },
  {
    id: 12,
    campaignName: 'Noticiero Matutino Sponsor',
    radioName: 'Radio Élite Digital',
    radioFrequency: '99.1 FM',
    radioCity: 'Madrid',
    totalAmount: 35000,
    radioPercent: 70,
    rfwPercent: 30,
    radioEarnings: 24500,
    rfwEarnings: 10500,
    impressions: 189000,
    clicks: 13500,
    listeners: 32000,
    engagement: 7.1,
    followers: 7100,
    startDate: '2026-06-01',
    endDate: '2026-09-01',
    status: 'activo',
    category: 'noticias',
    advertiserName: 'Banco Santander',
  },
];

export const revShareMetrics = {
  totalRevenue: 380500,
  totalRadioEarnings: 270000,
  totalRfwEarnings: 110500,
  totalImpressions: 1839000,
  totalClicks: 145700,
  totalListeners: 325500,
  avgEngagement: 7.0,
  totalFollowers: 70100,
  activeCampaigns: 8,
  radiosMonetizando: 8,
  avgRadioPercent: 70,
};